import { createContext } from 'react';
import { GestureResponderEvent } from 'react-native';

export interface AppContextInterface {
  explode: (evt: GestureResponderEvent) => void,
  setShowActivity: (showActivity: boolean) => void,
  showSpinner: () => void,
  hideSpinner: () => void,
};

export const AppContext = createContext<AppContextInterface>({
  explode: () => {},
  setShowActivity: () => {},
  showSpinner: () => {},
  hideSpinner: () => {},
});
